module.exports = __webpack_public_path__ + "img/MS_WeaponSword006.272edfa1.png";